import React from 'react';
import { SiteContent } from 'components/common/styles';
import ContentLayout from 'components/ContentLayout';
import LOTSetting from 'components/Admin/LOTSetting';
// eslint-disable-next-line
export default () => {
  return (
    <ContentLayout>
      <SiteContent>
        <LOTSetting />
      </SiteContent>
    </ContentLayout>
  );
};
